export enum EStatus {
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}
